import React, {useState} from 'react';
import { FaBars } from 'react-icons/fa'
import { useTranslation } from 'react-i18next';
import Logo from '../../../images/shareplug.png'
import { 
	Nav,
	NavbarContainer,
	NavLogo,
	MobileIcon,
	NavMenu,
	NavItem,
	NavLinks,
  NavLink
} from './NavbarElements';
import "../../../App.css"

const Navbar = ({toggle}) => {
  const {t, i18n} = useTranslation();
  function handleClick(lang){
    window.location.reload(i18n.changeLanguage(lang))
  }

  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if(window.scrollY >= 800) {
      setNavbar(true)
    } else{
      setNavbar(false);
    }
  }
  window.addEventListener("scroll", changeBackground)
	return (
		<>
			<Nav className={navbar ? 'navbar active' : Nav}>
				<NavbarContainer>
					<NavLogo to='home'><img src={Logo}  alt='' style={{width: "123px", height:"34px", marginTop:"5px"}}/></NavLogo>
					<MobileIcon onClick={toggle}>
						<FaBars/>
					</MobileIcon>
					<NavMenu>
						<NavItem>
							<NavLinks to="/notice">{t("issue")}</NavLinks>
						</NavItem>
						<NavItem>
							<NavLinks to="/user/faq">FAQ</NavLinks>
						</NavItem>
						<NavItem>
							<NavLink href="https://m.shareplug.co.kr/start" target="_blank" rel="noopener noreferrer" style={{marginRight: "6rem"}}>LOG IN</NavLink>
						</NavItem>
            <button className='glow-on-hover' onClick={()=> handleClick('en')}>English</button>
            <button className='glow-on-hover' onClick={()=> handleClick('ko')}>한국어</button>
					</NavMenu>
				</NavbarContainer>
			</Nav>		
		</>
	)
}

export default Navbar;
